import {
    addAdmin,
    removeAdmin,
    removeChatMember,
} from 'flow/actions/chat-actions';
import useAppContext from 'flow/hooks/useAppContext';
import { ChatMember } from 'flow/types/Chats';
import { ChatSessionKey } from 'flow/types/EntityKeys';

import { TypedMap } from 'flow/types/TypedMap';
import { routes } from 'flow/types/routes';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import {
    generatePath,
    useHistory,
    useLocation,
    useParams,
} from 'react-router-dom';
import useExtension from 'flow/hooks/useExtension';
import MenuItem from 'flow/components/ui-components/MenuItem';

interface Props {
    member: TypedMap<ChatMember>;
}

const MessageMemberContextMenu = ({ member }: Props) => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const { ownExtension } = useExtension();
    const { pathname } = useLocation();

    const { id } = useParams<{ id: ChatSessionKey }>();

    const session = useAppSelector((state) =>
        state.chats.getIn(['sessions', id]),
    );

    const isAdmin = session
        .get('admins')
        .includes(ownExtension.get('chatUserKey'));

    return (
        <>
            <MenuItem
                key="contact-card"
                onClick={() =>
                    history.push(
                        generatePath(
                            routes['messages.id.settings.members.contact.key'],
                            {
                                extensionKey: member.get('extensionKey'),
                                id,
                            },
                        ),
                        {
                            from: pathname,
                        },
                    )
                }
            >
                {i18next.t('Chat.Details.GoToContactCard')}
            </MenuItem>

            {isAdmin && (
                <>
                    {session.get('admins').includes(member.get('key')) ? (
                        <MenuItem
                            key="remove-admin"
                            onClick={() => {
                                dispatch(removeAdmin(id, member.get('key')));
                            }}
                        >
                            {i18next.t('Chat.Details.RemoveAdmin')}
                        </MenuItem>
                    ) : (
                        <MenuItem
                            key="make-admin"
                            onClick={() => {
                                dispatch(addAdmin(id, member.get('key')));
                            }}
                        >
                            {i18next.t('Chat.Details.MakeAdmin')}
                        </MenuItem>
                    )}

                    <MenuItem
                        key="remove-member"
                        onClick={() => {
                            dispatch(removeChatMember(id, member.get('key')));
                        }}
                    >
                        {i18next.t('Chat.Details.RemoveMember')}
                    </MenuItem>
                </>
            )}
        </>
    );
};

export default MessageMemberContextMenu;
